import { render, staticRenderFns } from "./Teambox.vue?vue&type=template&id=92e3aac0"
import script from "./Teambox.vue?vue&type=script&lang=js"
export * from "./Teambox.vue?vue&type=script&lang=js"
import style0 from "./Teambox.vue?vue&type=style&index=0&id=92e3aac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports